module.exports = __webpack_public_path__ + "static/media/header-img.bbb9e5ee.svg";